import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"

const ContentWrapper = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-family: Segoe UI;
    margin-bottom: 2rem;

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & span {
            font-size: 15px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        & span {
            font-size: 14px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        & span {
            font-size: 13px;
        }
    }
`

const ParentLinkUrl = styled(Link)`
    display: inline-block;
    color: ${(props) => props.theme.colors.primary};
`
const ParentLink = styled.span`
    display: inline-block;
    color: ${(props) => props.theme.colors.primary};
`
const ActiveLink = styled.span`
    display: inline-block;
    color: ${(props) => props.theme.colors.blue1};
`

const Slash = styled.span`
    margin: 0 0.5rem;
`

function BreadCrumbs({ links, parentLink }) {
    const linkList = links.map((data, index) => {
        // const link = data.toLowerCase().split(" ").join("-")
        let link = parentLink ? (
            <ParentLinkUrl key={index} to={`/${parentLink}`}>
                {data}
            </ParentLinkUrl>
        ) : (
            <ParentLink key={index}>{data}</ParentLink>
        )

        if (index === 0) {
            if (links.length === 1) {
                // parent url WITHOUT child
                return (
                    <ActiveLink style={{ marginLeft: "0" }} key={index}>
                        {data}
                    </ActiveLink>
                )
            }
            link = parentLink ? (
                <ParentLinkUrl
                    style={{ paddingLeft: "0" }}
                    key={index}
                    to={`/${parentLink}`}
                >
                    {data} <Slash>/</Slash>
                </ParentLinkUrl>
            ) : (
                <ParentLink style={{ paddingLeft: "0" }} key={index}>
                    {data} <Slash>/</Slash>
                </ParentLink>
            )

            // parent url WITH child
            return link
        } else if (index === links.length - 1) {
            return <ActiveLink key={index}>{data}</ActiveLink>
        }
        return link
    })
    const linkListHome = (
        <>
            <span>Home</span>
            {linkList && <Slash>/</Slash>}
            {linkList}
        </>
    )

    return <ContentWrapper>{linkListHome}</ContentWrapper>
}

export default BreadCrumbs
